export default __webpack_public_path__ + "static/media/red_circle.be869d19.gif";